module.exports = __webpack_public_path__ + "img/thumbnail_FormosanBlackBear_j_normal.8c73e081.png";